export const superconnectorReachoutMax = 5;

export const reachoutImportExampleLink =
  "https://docs.google.com/spreadsheets/d/1mf4DTqTva5VkyR8vuwQ-ha5_MeqvARmFCphSVI0AChg/edit?gid=1089884568#gid=1089884568";

export const directReachoutImportExampleLink =
  "https://docs.google.com/spreadsheets/d/1mf4DTqTva5VkyR8vuwQ-ha5_MeqvARmFCphSVI0AChg/edit?gid=21703886#gid=21703886";

export const reachoutMessagesExampleLink =
  "https://docs.google.com/spreadsheets/d/1mf4DTqTva5VkyR8vuwQ-ha5_MeqvARmFCphSVI0AChg/edit?gid=1851798331#gid=1851798331";
